import classNames from "clsx";
import { useTranslation } from "react-migration/lib/i18n/useTranslation";
import { RadioGroup } from "react-migration/components/RadioGroup";
import { SendOption } from "./SendOptions";

export type DownloadOptionProps = {
  onClick: React.MouseEventHandler<HTMLDivElement>;
};

export const DownloadOption = ({ onClick }: DownloadOptionProps) => {
  const { t } = useTranslation();

  return (
    <div
      className={classNames("flex", "flex-row", "items-center", "gap-3", "p-4", "cursor-pointer")}
      data-testid="send-option-download"
      onClick={onClick}
    >
      <RadioGroup.Item value={SendOption.Download} className="h-4! w-4!">
        <RadioGroup.Indicator />
      </RadioGroup.Item>
      <div className="flex items-center justify-center w-10 h-10 border-4 rounded-full border-platform-50 bg-platform-100">
        <i className="text-base icon-lt-download-line text-platform-600" />
      </div>
      <div className={classNames("flex", "flex-col")}>
        <span className={classNames("text-text-base-primary", "text-sm", "font-semibold", "leading-5")}>
          {t("sites.letters.download_and_send_yourself")}
        </span>
        <span className={classNames("text-text-base-secondary", "text-sm", "font-normal", "leading-5")}>
          {t("sites.letters.youll_have_full_control")}
        </span>
      </div>
    </div>
  );
};
